/* eslint-disable @typescript-eslint/no-empty-function */
import {
  GetProcessDetailDocument,
  UpdateItemDocument,
  UpdateItemMutation,
  UpdateItemMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { ValidationError } from 'modules/core/lib/errors'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useUpdateItem = () => {
  const [executeMutation] = useMutation(UpdateItemDocument, {
    extractorFn: (data: UpdateItemMutation) => data.processesMutations.patchProcessesItem,
  })

  const updateItem = async (variables: UpdateItemMutationVariables, processId: number) => {
    const rawResult = await executeMutation({
      variables,
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetProcessDetailDocument,
          variables: {
            id: processId,
          },
        },
      ],
    })

    const result = handleResult(rawResult, (errors) => {
      return app.setFlash({
        type: 'wrong',
        message: errors.messages || i18n.t('common.save_error'),
      })
    })

    if (!result.success)
      throw new ValidationError({ errors: i18n.t('processes.process_settings.save_error') })

    return result.data.item
  }

  return {
    updateItem,
  }
}
